import React, { useContext } from 'react';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import IconButtonWithTooltip from './IconButtonWithTooltip';
import LowPriorityIcon from '@mui/icons-material/LowPriority';
import { MarkDispatchContext, MarkStateContext } from '../../context/MarkContext';

import MarkReviewFormStyles from '../mark/form/MarkReviewForm.module.scss';

interface FieldActionsProps {
  isAddFieldActive?: boolean;
  isMarkModeActive?: boolean;
  isMarkPage?: boolean;
  onToggleMarkMode?: () => void;
  setAddFieldActive: (active: boolean) => void;
}

const FieldActions: React.FC<FieldActionsProps> = ({
  isAddFieldActive,
  isMarkModeActive,
  isMarkPage,
  onToggleMarkMode = () => {},
  setAddFieldActive,
}) => {
  const dispatch = useContext(MarkDispatchContext);
  const { selectedFields, showFieldCheckboxes } = useContext(MarkStateContext);

  const onAddNewField = () => {
    setAddFieldActive(!isAddFieldActive);
    // Deactivate DUPLICATE mode when adding a new field is activated.
    if (showFieldCheckboxes) dispatch({ type: 'SET_FIELD_CHECKBOXES', payload: false });
  };

  const onToggleDuplicateMode = () => {
    dispatch({ type: 'SET_FIELD_CHECKBOXES', payload: !showFieldCheckboxes });
    // Deactivate ADDING a new field when duplicate mode is activated.
    if (isAddFieldActive) setAddFieldActive(false);
  };

  const onConfirmDuplicate = () => {
    dispatch({ type: 'SET_DUPLICATE_MODAL', payload: true });
  };

  return (
    <div className={MarkReviewFormStyles.fieldActions}>
      <IconButtonWithTooltip
        color={isAddFieldActive ? 'primary' : undefined}
        cypressId="btn-new-field"
        icon={<AddCircleOutlineIcon />}
        onClick={onAddNewField}
        title="Add New Field"
      />
      {isMarkPage ? (
        <IconButtonWithTooltip
          color={isMarkModeActive ? 'primary' : undefined}
          cypressId="btn-mark-reorder"
          icon={<LowPriorityIcon />}
          onClick={onToggleMarkMode}
          title={isMarkModeActive ? 'Mark' : 'Reorder'}
        />
      ) : null}
      <IconButtonWithTooltip
        color={showFieldCheckboxes ? 'primary' : undefined}
        cypressId="btn-duplicate-fields"
        icon={<FileCopyIcon />}
        onClick={onToggleDuplicateMode}
        title="Duplicate Fields"
      />
      {showFieldCheckboxes && selectedFields.length > 0 && (
        <IconButtonWithTooltip
          color="primary"
          cypressId="btn-confirm-duplicate"
          icon={<CheckCircleIcon />}
          onClick={onConfirmDuplicate}
          title="Confirm Duplicate"
        />
      )}
    </div>
  );
};

export default FieldActions;
